module.exports = function(polls) {
	"use strict";
  polls
  .controller('pollController', pollController)
	pollController.$inject = ["$timeout","$filter","keyPressOnlyNumber","$parse","$attrs","$rootScope","$scope","getDataService", "jQuery","$state", "$stateParams","refreshtokenService","config","reqursiveService","putDataService","alertService","postDataService","deleteDataService","serverError","offlineError"];
	
  function pollController($timeout,$filter,keyPressOnlyNumber,$parse,$attrs,$rootScope,$scope,getDataService,jQuery,$state, $stateParams,refreshtokenService, config, reqursiveService, putDataService, alertService,postDataService,deleteDataService,serverError,offlineError) {
    var vmpl = this;
    var validation = true;
    vmpl.usernameRequired = false;
    vmpl.passwordRequired = false;
    vmpl.repeatpasswordRequired = false;
    vmpl.matchedpassword = false;
    var parent = $scope.$eval($attrs.parent);
    vmpl.editStatusShow = false;
    vmpl.minimumNumberOfQuestion = false;
    vmpl.titleRequired = false;
    vmpl.dataPoll = {};
    vmpl.keyPressOnlyNumber = keyPressOnlyNumber;
    vmpl.dataPoll.ads = false;
    vmpl.dataPoll.multiple = false; 
    vmpl.selectedPollStatus = {}
    var updateDate;
    vmpl.update = false;
    vmpl.editPollStatus = function() {
      vmpl.editPollStatusShow = true;
    }
    vmpl.changePollStatus = function() {
      vmpl.editPollStatusShow = false;
      vmpl.dataPoll.status = vmpl.selectedPollStatus.value;
    }
    vmpl.cancelEditPollStatus = function() {
      vmpl.editPollStatusShow = false;
      vmpl.selectedPollStatus = {value: vmpl.dataPoll.status};
    }
    vmpl.openSetFeaturedImage = function() {
      vmpl.mediaModal = true;
      vmpl.setFeaturedImage = true;
      $rootScope.modalShow = true;
    }
    vmpl.cancelImageModal = function() {
      $rootScope.modalShow = false;
      vmpl.mediaModal = false;
      vmpl.setFeaturedImage = false;
    }
    vmpl.removeFeaturedImage = function() {
      vmpl.hasFeaturedImage = false;
      vmpl.featured_img_obj = undefined;
      vmpl.featured_img_id = undefined;
    }
    vmpl.cancelEditStatus = function() {
      vmpl.editStatusShow = false;
      vmpl.dataPoll.status = vmpl.copyStatus;
    }
    vmpl.editStatus = function(status) {
      if(status) {
        vmpl.copyStatus = angular.copy(status);  
      }
      vmpl.editStatusShow = true;
    }
    vmpl.submitEditStatus = function() {
      vmpl.editStatusShow = false;
    }
    vmpl.switchStatus = function(status) {
      vmpl.dataPoll.status = status;
    }
    vmpl.editPollDate = function() {
      vmpl.editPollDateShow = true;
      if(!vmpl.dataPoll.expire_date) {
        convertTimeFunction(undefined);
      } 
    }
    vmpl.cancelEditPollDate = function() {
      vmpl.editPollDateShow = false; 
    }
    
    vmpl.setPollDate = function() {
      vmpl.editPostDateShow = false; 
      var dateArray = [vmpl.pollYear, parseInt(vmpl.selectedPollMonth.value)-1, vmpl.pollDay, vmpl.pollHours, vmpl.pollMinutes];
      updateDate = moment(dateArray).toISOString();
      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>60) {
        vmpl.dataPoll.expire_date = $filter('date')(updateDate, "MMM d, y HH:mm");
        vmpl.editPollDateShow = false
      } else {
        alertService('danger','Opps! ', 'The date is not valid. The set date must be at least 60 minutes from now.');
      }
    }
    function convertTimeFunction(date) {
      var a = moment(date);
      var year = a.format('YYYY');
      var month = a.format('M');
      var day = a.format('D');
      var hour = a.hours();
      var min = a.minutes();
      vmpl.pollYear = year;
      vmpl.selectedPollMonth = {value: month};
      vmpl.pollDay = day;
      if(hour<10) {
        vmpl.pollHours = '0'+hour;  
      } else {
        vmpl.pollHours = hour;
      }
      if(min<10) {
        vmpl.pollMinutes = '0'+min;  
      } else {
        vmpl.pollMinutes = min;
      }
    } 
    vmpl.actionWithPoll = function() {
      vmpl.validation = true;
      if(!vmpl.dataPoll.title) {
        vmpl.titleRequired = true;
        alertService('danger','Opps! ', 'Title is required');
        vmpl.validation = false;
      } else {
        vmpl.titleRequired = false;
      }
      for(var i=0; i<vmpl.choices.length;i++) {
        if(!vmpl.choices[i].counter) {
          vmpl.choices[i].counter = 0;
        }
        if(!vmpl.choices[i].text) {
          alertService('danger','Opps! ', 'Text question is required');
          vmpl.textQuestionRequired = true;
          vmpl.validation = false;
        } else {
          vmpl.textQuestionRequired = false;
        }
      }
      if(vmpl.dataPoll.multiple && vmpl.dataPoll.max_choices && (vmpl.dataPoll.max_choices <2 || vmpl.dataPoll.max_choices >vmpl.choices.length)) {
        vmpl.validation = false;
        alertService('danger','Opps! ', 'The maximum number of choices must not exceed the number of questions and should be greater than or equal to 2.');
        vmpl.maxChoicesInvalid = true;
      } else {
        vmpl.maxChoicesInvalid = false
      }
      if(vmpl.validation) {
        $rootScope.hasLoaded = false;
        var expire_date = null;
        if(vmpl.dataPoll.status=='finish'){
          expire_date = $filter('date')(new Date().toISOString(), "MMM d, y HH:mm")
        } else if(vmpl.dataPoll.status=='publish') {
          if(vmpl.dataPoll.expire_date && new Date(vmpl.dataPoll.expire_date).getTime() > new Date().getTime()) {
            expire_date = vmpl.dataPoll.expire_date
          }
        }
        var updateData = {
          'title':vmpl.dataPoll.title,
          'content': vmpl.dataPoll.content,
          'status': vmpl.dataPoll.status,
          'data':vmpl.choices,
          'multiple': vmpl.dataPoll.multiple,
          'max_choices': (vmpl.dataPoll.multiple && vmpl.dataPoll.max_choices)?vmpl.dataPoll.max_choices:null,
          "image": (vmpl.featured_img_id)? vmpl.featured_img_id: undefined,
          "expire_date": expire_date,
          "ads": vmpl.dataPoll.ads
        }
        if(!parent) {
          var postFunction = function() {
            postDataService.save({
              param1:'polls', 
            },updateData).$promise.then(function(postPoll){
              $rootScope.hasLoaded = true;
              vmpl.dataPoll = {};
              vmpl.choices = [{'text': '','counter':0}];
              alertService('success','Success ', postPoll.message, 2000);
              if(postPoll && postPoll.obj && postPoll.obj._id) {
                $state.go('app.allpolls',{id:postPoll.obj._id});
              }
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {   
                     postFunction();
                    }
                  },
                  function(error) {
                    // report something
                  },
                  function(progress) {
                   // report progress
                });
              } else if(error.status ==502) {
                serverError()
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;  
            });
          }
          postFunction();
        } else {
          var putFunction = function() {
            putDataService.update({
              param1:'polls', 
              param2:vmpl.dataPoll._id
            },updateData).$promise.then(function(putPoll){
                $rootScope.hasLoaded = true;
                populateData(putPoll.obj,true)
                alertService('success','Success ', putPoll.message, 2000);
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {   
                      putFunction();
                    }
                  },
                  function(error) {
                    // report something
                  },
                  function(progress) {
                   // report progress
                });
              } else if(error.status ==502) {
                serverError()
              }else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;  
            });
          }
          putFunction();
        }
      }
    }
    vmpl.trashPoll = function() {
      vmpl.dataPoll.status = 'trash';
      vmpl.selectedPollStatus = {value:'trash'};
      vmpl.actionWithPoll();
    }
    vmpl.publishPoll = function() {
      vmpl.dataPoll.status = 'publish';
      vmpl.selectedPollStatus = {value:'publish'};
      vmpl.actionWithPoll();
    }
    vmpl.updatePoll = function() {
      vmpl.actionWithPoll();
    }
    function populateData(data, update) {
      vmpl.update = false;
      vmpl.dataPoll = data;
      vmpl.dataPoll.content = (vmpl.dataPoll.content)?vmpl.dataPoll.content:'';
      if(update) {
        $timeout(function(){
          vmpl.update = true;
        },0)
      }
      vmpl.choices = vmpl.dataPoll.data.answers;
      vmpl.selectedPollStatus.value = vmpl.dataPoll.status;
      if(vmpl.dataPoll.image) {
        vmpl.hasFeaturedImage = true;
        vmpl.featured_img_obj = vmpl.dataPoll.image; 
        vmpl.featured_img_id = vmpl.dataPoll.image._id;
      }
      if(vmpl.dataPoll.expire_date) {
        vmpl.dataPoll.expire_date = $filter('date')(vmpl.dataPoll.expire_date, "MMM d, y HH:mm");
        convertTimeFunction(vmpl.dataPoll.expire_date);
      } else {
        convertTimeFunction(undefined);
      }
    }
    if(parent) {
      vmpl.pollId = parent.pollId;
      vmpl.newPoll = false;
      $rootScope.closeEditPoll = function() {
        $rootScope.ngEscapeAttrsParametars = [];
        parent.editPollShow = false;
        vmpl.dataPoll = null;
        $state.transitionTo('app.allpolls', {id: null}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      }
      var getPollFunction = function() { 
        $rootScope.hasLoaded = false;
        getDataService.get({param1:'polls', param2: vmpl.pollId, param3:null}).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          populateData(data)
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError('refresh')
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                getPollFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            parent.editPollShow = false;
            vmpl.dataPoll = null;
            $rootScope.hasLoaded = false;
            $state.transitionTo('app.allpolls', {id: null}, {
              location: true,
              inherit: true,
              relative: $state.$current,
              notify: false
            });
          }
        });
      }
      getPollFunction();
    } else {
      vmpl.newPoll = true;
      vmpl.dataPoll.content = ''
    }
    vmpl.choices = [{'text': '','counter':0}, {'text': '','counter':0}];
    vmpl.addNewChoice = function() {
      vmpl.choices.push({'text': '','counter':0});
    };
    vmpl.removeChoice = function() {
      var lastItem = vmpl.choices.length-1;
      if (vmpl.choices.length>2) {
        vmpl.choices.splice(lastItem);
      } else {
        return
      }
    }; 
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pollsModule/edit-newpoll/js/pollController.js
// module id = 543
// module chunks = 0